import { render } from "./accountCollect.vue?vue&type=template&id=454ac95f&scoped=true"
import script from "./accountCollect.vue?vue&type=script&lang=js"
export * from "./accountCollect.vue?vue&type=script&lang=js"

import "./accountCollect.vue?vue&type=style&index=0&id=454ac95f&lang=scss"
import "./accountCollect.vue?vue&type=style&index=1&id=454ac95f&lang=scss&scoped=true"
import "./accountCollect.vue?vue&type=style&index=2&id=454ac95f&lang=css"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454ac95f"]])

export default __exports__